export const INVOICE_PRODUCER_STATUS = {
  REQUESTED: 'Requested',
  IN_DISPUTE: 'In Dispute',
  APPROVED: 'Approved',
  RECEIVED: 'Received',
  PAYMENT_SENT: 'Paid',
  PAYMENT_PROCESSING: 'Processing',
  PAYMENT_FAILED: 'Failed'
};

export const INVOICE_STATUS_SUMMARY_STATUS = {
  ALL: 'All',
  REQUESTED: INVOICE_PRODUCER_STATUS.REQUESTED,
  RECEIVED: INVOICE_PRODUCER_STATUS.RECEIVED,
  APPROVED: INVOICE_PRODUCER_STATUS.APPROVED,
  IN_DISPUTE: INVOICE_PRODUCER_STATUS.IN_DISPUTE
};

export const PAYMENT_SUMMARY_STATUS = {
  PAYMENT_SENT: INVOICE_PRODUCER_STATUS.PAYMENT_SENT,
  PAYMENT_PROCESSING: INVOICE_PRODUCER_STATUS.PAYMENT_PROCESSING,
  PAYMENT_FAILED: INVOICE_PRODUCER_STATUS.PAYMENT_FAILED
};

export const INVOICE_STATUS_SUMMARY_STATUS_COLOR = {
  [INVOICE_STATUS_SUMMARY_STATUS.ALL]: {
    light: 'var(--ruthless-empress)',
    dark: ''
  },
  [INVOICE_STATUS_SUMMARY_STATUS.REQUESTED]: {
    light: 'var(--silverberry)',
    dark: 'var(--amethyst-haze)'
  },
  [INVOICE_STATUS_SUMMARY_STATUS.RECEIVED]: {
    light: 'var(--blue-party-parrot)',
    dark: 'var(--borage-blue)'
  },
  [INVOICE_STATUS_SUMMARY_STATUS.IN_DISPUTE]: {
    light: 'var(--butternut)',
    dark: 'var(--burning-sand)'
  },
  [INVOICE_STATUS_SUMMARY_STATUS.APPROVED]: {
    light: 'var(--boogie-blast)',
    dark: 'var(--intermediate-green)'
  },
  [PAYMENT_SUMMARY_STATUS.PAYMENT_SENT]: {
    light: 'var(--boogie-blast)',
    dark: ''
  },
  [PAYMENT_SUMMARY_STATUS.PAYMENT_PROCESSING]: {
    light: 'var(--cobalite)',
    dark: ''
  },
  [PAYMENT_SUMMARY_STATUS.PAYMENT_FAILED]: {
    light: 'var(--flushed)',
    dark: ''
  }
};

export const getInvoiceStatusesList = () => {
  return Object.values(INVOICE_STATUS_SUMMARY_STATUS).reduce((acc, status) => {
    const newStatus = {
      status,
      color: INVOICE_STATUS_SUMMARY_STATUS_COLOR[status].light,
      count: 0
    };
    acc.push(newStatus);
    return acc;
  }, []);
};

export const getPaymentSummaryStatusesList = () => {
  return Object.values(PAYMENT_SUMMARY_STATUS).reduce((acc, status) => {
    const newStatus = {
      status,
      color: INVOICE_STATUS_SUMMARY_STATUS_COLOR[status].light,
      count: 0
    };
    acc.push(newStatus);
    return acc;
  }, []);
};

export const FINANCE_STATUS_FILTER_TYPE = {
  ALL: 'All',
  REQUESTED: 'Received',
  APPROVED: 'Approved',
  IN_DISPUTE: 'In Dispute',
  PROCESSING: 'Processing',
  PAID: 'Paid',
  SENT: 'Sent',
  OVERDUE: 'Overdue',
  INVOICE_SAVED: 'Invoice Saved '
};

export const SHORT_STATUS = (status) => {
  switch (status) {
    case PAYMENT_SUMMARY_STATUS.PAYMENT_SENT:
      return PAYMENT_SUMMARY_STATUS.PAYMENT_SENT;
    case PAYMENT_SUMMARY_STATUS.PAYMENT_PROCESSING:
      return PAYMENT_SUMMARY_STATUS.PAYMENT_PROCESSING;
    case PAYMENT_SUMMARY_STATUS.PAYMENT_FAILED:
      return PAYMENT_SUMMARY_STATUS.PAYMENT_FAILED;
    default:
      return null;
  }
};

// Used only in client/src/containers/Company/Finance/routes/Invoices/Invoices.js
export const FINANCE_STATUS_FILTER_LIST = [
  {
    status: FINANCE_STATUS_FILTER_TYPE.ALL
  },
  {
    status: FINANCE_STATUS_FILTER_TYPE.REQUESTED
  },
  {
    status: FINANCE_STATUS_FILTER_TYPE.SENT
  },
  {
    status: FINANCE_STATUS_FILTER_TYPE.OVERDUE
  },
  {
    status: FINANCE_STATUS_FILTER_TYPE.IN_DISPUTE
  }
];
